import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { StateSchema } from 'src/shared/config/StateSchema';
import { AppDispatch } from 'src/shared/config/store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<StateSchema> = useSelector;
